import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=15aaa5c1&scoped=true"
import script from "./Settlements.vue?vue&type=script&lang=js"
export * from "./Settlements.vue?vue&type=script&lang=js"
import style0 from "./Settlements.vue?vue&type=style&index=0&id=15aaa5c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aaa5c1",
  null
  
)

export default component.exports